// extracted by mini-css-extract-plugin
export default {"crossIcon":"style_crossIcon__mek2j","title":"style_title__uRCVK","textArea":"style_textArea__Qbv08","errorText":"style_errorText__6hh52"};